import { FC, PropsWithChildren } from 'react';

import { ThemeProvider as MantineThemeProvider, CSSVariablesResolver } from '@ui';

export const MantineLayout: FC<PropsWithChildren> = ({ children }) => {
  const appResolver: CSSVariablesResolver = () => ({
    variables: {
      '--dwa-container-width': '1124px'
    },
    light: {},
    dark: {}
  });

  return (
    <MantineThemeProvider resolver={appResolver}>{children}</MantineThemeProvider>
  );
};
